var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskProfiler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.75L10.15 12.35C10.8526 11.6465 11.8058 11.2508 12.8 11.25H16.25C16.913 11.25 17.5489 11.5134 18.0178 11.9822C18.4866 12.451 18.75 13.0869 18.75 13.75C18.75 14.413 18.4866 15.0489 18.0178 15.5177C17.5489 15.9866 16.913 16.25 16.25 16.25H13.125M18.125 15.4L23.3375 9.28746C23.7402 8.84108 24.2987 8.56601 24.898 8.51884C25.4974 8.47168 26.092 8.65601 26.5596 9.03391C27.0271 9.41181 27.3321 9.95454 27.4117 10.5504C27.4913 11.1463 27.3395 11.7501 26.9875 12.2375L21.7375 19.6625C21.3938 20.1494 20.939 20.5474 20.4107 20.8235C19.8825 21.0996 19.296 21.2458 18.7 21.25H12.2875C11.9576 21.2497 11.6309 21.3147 11.3263 21.4413C11.0217 21.5679 10.7451 21.7535 10.5125 21.9875L8.75 23.75",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5L10 25",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfiler);
export default __webpack_public_path__ + "static/media/RiskProfiler.b23d9d80b16d3af97ffa5dd0f97c0e56.svg";
export { ForwardRef as ReactComponent };